document.addEventListener('DOMContentLoaded', function () {
  const preferred = JSON.parse(localStorage.getItem('preferredLocation')) || null;
  if (preferred) {
    filterProductsByTag(preferred.id);
  }
});

function filterProductsByTag(location) {
  const products = document.querySelectorAll('product-card');
  products.forEach((product) => {
    const policy = product.getAttribute('data-inventory-policy') === 'continue';
    if(!policy){
      const locationTags = product?.getAttribute('data-locations')?.split(',');
      const unavailableLabel = product.querySelector('.product-label-location-out');
      const button = product.querySelector('button');
      if (!locationTags?.includes(location)) {
        product.classList.add('location-sold-out');
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        unavailableLabel.classList.remove('hidden');
      }
    }
  });
}